module.exports = __webpack_public_path__ + "assets/blog3.15fa39ac.jpg";